import {$qsAll, $qs} from '../../../@shared/ts/dom';
import {FeatureFlag} from '../../../@type/features';
import {Feature} from '../reducers/environmentReducer';

function initMerchantLogo() {
	const logoSrc = Feature.metadata<string>(FeatureFlag.MERCHANT_LOGO, 'logo_src');
	if (Feature.enabled(FeatureFlag.MERCHANT_LOGO) && logoSrc) {
		$qsAll('.pp-merchant-logo-container', $el => {
			$el.insertAdjacentHTML('afterbegin', /* html */ `<img class="pp-merchant-logo" src="${logoSrc}">`);
			$el.style.opacity = '1';
			$el.classList.remove('hide');
		});

		$qs('#pp-checkout-status-container')?.classList.remove('center');
		$qs('#pp-checkout-status-container')?.classList.add('merchant-logo');
	} else {
		$qsAll('.pp-merchant-logo-container', $el => {
			$el.style.opacity = '0';
		});
	}
}

export {initMerchantLogo};
